(() => {
    const nav = document.querySelector('.rc-tabs');
    if (!nav) return;

    const list = nav.querySelector('.rc-tabs__list');
    const active = nav.querySelector('.rc-tabs__link.is-active');
    if (!list || !active) return;

    // Only relevant when horizontal scroll is possible (mobile-ish)
    const canScrollX = list.scrollWidth > list.clientWidth + 2;
    if (!canScrollX) return;

    // If active is already fully visible, do nothing
    const listRect = list.getBoundingClientRect();
    const aRect = active.getBoundingClientRect();
    const fullyVisible = aRect.left >= listRect.left && aRect.right <= listRect.right;

    if (!fullyVisible) {
        // Bring active tab into view, centred-ish
        active.scrollIntoView({
            block: 'nearest',
            inline: 'center',
            behavior: 'smooth'
        });
    }
})();
